export default __webpack_public_path__ + "static/media/question-mark-blue.3ae7e991.svg";